import React from 'react';
import classNames from 'classnames';

const Button = props => {
    
    const { modifiers, children, ...rest} = props;
    
    return (
        <button className={classNames({
            'form__button': true,
            ...modifiers
        })} {...rest}>{children}</button>
    );
};

export default Button;